import { Vue, Watch, Component, Prop } from 'vue-property-decorator';
import addSize from './addSizeMapping';
import sizeMappingUpload from './sizeMappingUpload';
import style from './style.vue';
import { QinggerLibUtils, noop } from '@/util';
import { IPSService } from '@/services/ipsServices';
const isset = QinggerLibUtils.isset;

@Component({
  mixins: [style],
})
export default class SizeChart extends Vue {
  public sizeList = [];

  public tableData = [];

  public attributeList = [];

  public selected: ItemObject = {};

  public selectIndex = 0;

  public attributeListStore = [];

  public curTab = '1';

  async mounted() {
    this.getData();
    this.attributeList = await this.getAttributeList();
    this.attributeListStore = this.computedTree(this.attributeList);
  }

  computedTree(list = [], result = []) {
    list.forEach((v) => {
      const item = {
        class_code: '',
        class_name: '',
        value_no: '',
        value_name: '',
      };
      item.class_code = v.attrCode || v.class_code;
      item.class_name = v.attrCode ? v.attrName : this.attributeList.find(v => v.attrCode === item.class_code).attrName;
      item.value_no = v.attrCode || v.value_no;
      item.value_name = v.attrName || v.value_name;
      result.push(item);
      if (v.list && v.list.length) {
        this.computedTree(v.list, result);
      }
    });
    return result;
  }

  getAttributeList(): Promise<any> {
    return IPSService.getAttributeList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  computedAttributeName(codes) {
    return codes
      .map((val) => {
        return this.computedClassName(val);
      })
      .join('；');
  }

  computedClassName(val: { attrCode: string; attrValues: string }): string {
    val = Object.assign({}, { attrCode: '', attrValues: '' }, val);
    const parentAttr = this.attributeListStore.find(v => v.class_code === v.value_no && v.class_code && val.attrCode === v.class_code);
    const parentName = parentAttr ? parentAttr.class_name : '';
    const attrValues = val.attrValues.split(',');
    const childrenName = this.attributeListStore
      .filter(v => attrValues.includes(v.value_no))
      .map(vl => vl.value_name)
      .join('、');
    return `${parentName} ： ${childrenName}`;
  }

  getData() {
    IPSService.sizeMappingInfo({ postParams: {} }).then((response) => {
      this.sizeList = response.list;
      if (this.selected.gsmId) {
        this.selected = (response.list || []).find(v => v.gsmId === this.selected.gsmId) || {};
        this.selectIndex = (response.list || []).findIndex(v => v.gsmId === this.selected.gsmId);
      }
      if (!this.selected.gsmId) {
        this.selectIndex = 0;
        this.selected = response.list[0] || {};
      }
      this.tableData = this.selected.sizeConfig || [];
      this.$nextTick(() => {
        if (this.$el.querySelector('.selected')) {
          this.$el.querySelector('.selected').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  onSelected(index: number) {
    this.tableData = this.sizeList[index].sizeConfig;
    this.selected = this.sizeList[index];
    this.selectIndex = index;
  }

  addSizeChart() {
    addSize.open({ attributeListStore: this.attributeListStore }).then((result) => {
      this.getData();
    }, noop);
  }

  uploadSizeChart() {
    sizeMappingUpload
      .open({
        gsmId: this.selected.gsmId,
        contrastName: this.selected.contrastName,
        originName: this.selected.originName,
        sizeConfig: this.selected.sizeConfig,
      })
      .then((result) => {
        this.getData();
      }, noop);
  }

  clearAll() {
    this.$confirm('是否清除当前表格内容？', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.sizeMappingClearAll({
          postParams: {
            gsmId: this.selected.gsmId,
          },
        }).then((response) => {
          this.$message.success('清除成功');
          this.getData();
        });
      }
    });
  }

  removeItem(e, index) {
    e.stopPropagation();
    this.$confirm('确定移除该尺码对照表？').then((result) => {
      if (result === 'confirm') {
        IPSService.sizeMappingDelete({
          postParams: {
            gsmId: this.sizeList[index].gsmId,
          },
        }).then((response) => {
          this.$message.success('删除成功');
          this.getData();
        });
      }
    }, noop);
  }

  renderSizeInfo(h) {
    return (
      <div style="height: 100%">
        <el-tooltip class="item" effect="light" content={`${this.computedAttributeName(this.selected.attrList)}`} placement="top-start">
          <div class="size-bind-class">{this.computedAttributeName(this.selected.attrList)}</div>
        </el-tooltip>
        <el-row class="size-table">
          <el-row class="bg-grey-11">
            <el-col span={5} class="center r-px-0 r-py-8">
              {this.selected.originName}
            </el-col>
            <el-col span={5} style="text-align: center;padding: 8px 0">
              {this.selected.contrastName}
            </el-col>
          </el-row>
          {this.tableData.map((v, i) => {
            return (
              <el-row key={i} style={{ background: i % 2 === 0 ? '' : '#f2f2f2', padding: '8px 0' }}>
                <el-col span={5} style="text-align: center">
                  {v.size}
                </el-col>
                <el-col span={5} style="text-align: center">
                  {v.newSize}
                </el-col>
              </el-row>
            );
          })}
        </el-row>
        <div class="bottomWrapper" style="padding: 10px 10px 16px 0px">
          <el-button type="primary" onClick={this.uploadSizeChart.bind(this)}>
            上传尺码对照表
          </el-button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span class="scopeSpan" onClick={this.clearAll.bind(this)}>
            清除全部
          </span>
        </div>
      </div>
    );
  }

  render(h) {
    return (
      <el-container class="size-mapping height-100">
        <el-aside class="wid-75">
          {this.sizeList.map((val, index) => {
            return (
              <div class={['size-item', this.selectIndex === index && 'selected']} key={index} onClick={this.onSelected.bind(this, index)}>
                {`${val.originName}->${val.contrastName}`}
                <i class="iconfont iconlajitong" onClick={e => this.removeItem(e, index)} />
              </div>
            );
          })}
          <div class="size-item scopeSpan r-ma-0" onClick={this.addSizeChart.bind(this)}>
            新建尺码对照表
          </div>
        </el-aside>
        <el-main class="r-px-16 r-py-0">{this.selected.gsmId ? this.renderSizeInfo(h) : <div></div>}</el-main>
      </el-container>
    );
  }
}
